import styled from 'styled-components'

/**
 ** overflow: hidden;
 ** position: relative;
 ** width: 100%;
 ** aspect-ratio: 1/1.3;
 ** object-fit: cover;
 ** radius?: border-radius: ${radius}px;
 ** isShadow?: background: linear-gradient(179.87deg, rgba(0, 0, 0, 0) 63.83%, rgba(0, 0, 0, 0.77) 99.89%);
 */
export const StyledProductCard = styled.div<{ radius?: 8 | 16 | number; isShadow?: boolean }>`
  overflow: hidden;
  position: relative;
  width: 100%;
  aspect-ratio: 1/1.3;
  object-fit: cover;
  ${({ radius }) => (radius ? `border-radius: ${radius}px;` : '')}
  ${({ isShadow }) =>
    isShadow
      ? `
          &::after {
            display: block;
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: -1;
            width: 100%;
            height: 100%;
            background: linear-gradient(179.87deg, rgba(0, 0, 0, 0) 63.83%, rgba(0, 0, 0, 0.77) 99.89%);
          }
        `
      : ''}
`
